/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_Readonly_ToastInputs */

const vi_impersonation_readonly_toast = /** @type {(inputs: Impersonation_Readonly_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể thực hiện thao tác này khi đang xem với tư cách người khác.`)
};

/**

* @param {Impersonation_Readonly_ToastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const impersonation_readonly_toast = /** @type {((inputs?: Impersonation_Readonly_ToastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_Readonly_ToastInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_impersonation_readonly_toast(inputs)
});